export default __webpack_public_path__ + "static/media/Selectvideo.a0e58d98.svg";